<div class="manage-con">
    <ul class="manage-nav">
        {{if RoleID == 2}}
            <li class="active">咨询师</li>
        {{else if RoleID == 7}}
            <li class="active">特约咨询师</li>
        {{else if RoleID == 4}}
            <li class="active">专家</li>
        {{/if}}
        <!--
        {{if LiveType == 1}}
            <li>普通主播</li>
        {{else if LiveType == 2}}
            <li>特约主播</li>
        {{else if LiveType == 3}}
            <li>官方主播</li>
        {{/if}}
        -->
    </ul>
    <div class="manage-content">
    {{if RoleID == 2}}
        <div class="manage-content-item active angel" id="">
            <div class="level-con clearfix">
                <div class="level-info fl">
                    <h4>当前星级:{{LevelManageInfo.CurrentUserLevel}}</h4>
                    <span id="angelLeveldes">咨询师星级说明?</span>
                </div>
                <div class="set-btn-wrap fr">
                    <span>资费设置：{{LevelManageInfo.CallMinuteAmount}}</span>
                    <a class="set-btn setfee">设置资费</a>
                </div>
            </div>
            <div class="standard">
                <table>
                    <thead>
                        <tr>
                            <th>{{LevelManageInfo.CurrentUserLevel}}升{{LevelManageInfo.NextUserLevel}}要求</th>
                            <th>达标情况</th>
                        </tr>
                    </thead>
                    <tbody>
                    {{each LevelManageInfo.UpLevelRequireList item}}
                        {{if item.State }}
                            <tr>
                                <td>{{item.Title}}</td>
                                <td>{{item.CompleteRate}}</td>
                            </tr>
                        {{else}}
                            <tr class="active">
                                <td>{{item.Title}}</td>
                                <td>{{item.CompleteRate}}</td>
                            </tr>
                        {{/if}}
                    {{/each}}
                    </tbody>
                </table>
            </div>
            <div class="statistics">
                <p class="table-tit">每月数据统计</p>
                <table>
                    <thead>
                        <tr>
                            <th>月份</th>
                            <th>接听时长(分钟)</th>
                            <th>接听成功次数</th>
                            <th>总收入</th>
                        </tr>
                    </thead>
                    <tbody>
                        {{each UserCallNumAndIncome item}}
                            <tr>
                                <td>{{item.Date}}</td>
                                <td>{{item.CallMinute || 0}}</td>
                                <td>{{item.SuccessCallNum || 0}}</td>
                                <td>{{item.ToTalMoney || 0}}</td>
                            </tr>
                        {{/each}}
                    </tbody>
                </table>
            </div>
        </div>
    {{else if RoleID == 7}}
        <div class="manage-content-item active sangel" id="">
            <div class="level-con clearfix">
                <div class="level-info fl">
                    <h4>当前角色:特约咨询师</h4>
                </div>
                <div class="set-btn-wrap fr">
                    <span>资费设置：{{LevelManageInfo.CallMinuteAmount}}</span>
                    <a class="set-btn setfee">设置资费</a>
                </div>
            </div>
            <div class="statistics">
                <p class="table-tit">每月数据统计</p>
                <table>
                    <thead>
                        <tr>
                            <th>月份</th>
                            <th>接听时长(分钟)</th>
                            <th>接听成功次数</th>
                            <th>总收入</th>
                        </tr>
                    </thead>
                    <tbody>
                        {{each UserCallNumAndIncome item}}
                            <tr>
                                <td>{{item.Date}}</td>
                                <td>{{item.CallMinute || 0}}</td>
                                <td>{{item.SuccessCallNum || 0}}</td>
                                <td>{{item.ToTalMoney || 0}}</td>
                            </tr>
                        {{/each}}
                    </tbody>
                </table>
            </div>
        </div>
    {{else if RoleID == 4}}
        <div class="manage-content-item active expert" id="">
            <div class="level-con clearfix">
                <div class="level-info fl">
                    <h4>当前角色:专家</h4>
                </div>
                <div class="set-btn-wrap fr">
                    <span>资费设置：{{LevelManageInfo.CallMinuteAmount}}</span>
                    <a class="set-btn setfee">设置资费</a>
                </div>
            </div>
            <div class="statistics">
                <p class="table-tit">每月数据统计</p>
                <table>
                    <thead>
                        <tr>
                            <th>月份</th>
                            <th>接听时长(分钟)</th>
                            <th>接听成功次数</th>
                            <th>总收入</th>
                        </tr>
                    </thead>
                    <tbody>
                        {{each UserCallNumAndIncome item}}
                            <tr>
                                <td>{{item.Date}}</td>
                                <td>{{item.CallMinute || 0}}</td>
                                <td>{{item.SuccessCallNum || 0}}</td>
                                <td>{{item.ToTalMoney || 0}}</td>
                            </tr>
                        {{/each}}
                    </tbody>
                </table>
            </div>
        </div>
    {{/if}}
    <!--
    {{if LiveType == 1 || LiveType == 2 || LiveType == 3}}
        <div class="manage-content-item anchor" id="">
            <div class="level-con clearfix">
                <div class="level-info fl">
                    <h4>当前角色:主播</h4>
                </div>
            </div>
            <div class="statistics">
                <p class="table-tit">每月数据统计</p>
                <table>
                    <thead>
                        <tr>
                            <th>月份</th>
                            <th>接听时长(分钟)</th>
                            <th>接听成功次数</th>
                            <th>总收入</th>
                        </tr>
                    </thead>
                    <tbody>
                        {{each UserCallNumAndIncome item}}
                            <tr>
                                <td>{{item.Date}}</td>
                                <td>{{item.CallMinute || 0}}</td>
                                <td>{{item.SuccessCallNum || 0}}</td>
                                <td>{{item.ToTalMoney || 0}}</td>
                            </tr>
                        {{/each}}
                    </tbody>
                </table>
            </div>
        </div>
    {{/if}}
    -->   
    </div>
</div>

<div id="setFee-con" style="display: none">
    <div class="ui-dialog-title clearfix">
        <p>设置资费</p>
    </div>
    <div class="labelList-con clearfix">
        <form style="padding:0 120px">
            <div class="form-data-item" style="position: relative;">
                <div class="form-block layui-form" style="width: 260px">
                    <select id="feeInput"></select>
                </div>
            </div>
            <div class="form-data-item">
                <div style="text-align: center;color: #666">资费区间：{{LevelManageInfo.ExpensesConfig.MinFeeAmount}}-{{LevelManageInfo.ExpensesConfig.MaxFeeAmount}}声币/分钟</div>   
            </div>
        </form>
    </div>
    <div class="btn-wrap" style="">
        <a class="btn-confirm" id="setExpenses">确认修改</a>
    </div>
</div>